var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "donut", class: _vm.classDonut }, [
    _c("h2", [_vm._v(_vm._s(_vm.val) + _vm._s(_vm.units))]),
    _vm._v(" "),
    _c("svg", [
      _c("g", [
        _c("title", [_vm._v("Layer 1")]),
        _vm._v(" "),
        _c("circle", {
          staticClass: "circle_animation",
          attrs: { r: "69.85699", cy: "81", cx: "81", fill: "none" }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Misc/Donut.vue?vue&type=template&id=9b69eb12&
// module id = null
// module chunks = 